import {
  PayPalCardFieldsProvider,
  PayPalCVVField,
  PayPalExpiryField,
  PayPalNameField,
  PayPalNumberField,
  usePayPalCardFields,
  PayPalButtons,
} from "@paypal/react-paypal-js";

import BusinessPartnerService from "../../service/Cadastros/BusinessPartnerService";
import AreaManagerService from "../../service/Cadastros/AreaManagerService";
import localeText from "../../locale";

import { useRef, useState } from "react";
import { Button } from "primereact/button";
import GetInfoService from "../../service/GetInfoService";
import SellerService from "../../service/Cadastros/SellerService";
import { useToastContext } from "../../contexts/ToastContext/ToastContext";
import AdvancedPayPalService from "../../service/AdvancedPayPalService";
import paypalImg from "../../pages/images/paypal.png";
import masterCardImg from "../../pages/images/masterCard.png";
import americanExpress from "../../pages/images/expressoAmericano.png";
import visa from "../../pages/images/visa.png";
import PagamentoSeguro from "../../pages/images/pagamentoSeguro.png";

const SubmitPayment = ({ isPaying, setIsPaying, toast }) => {
  const { cardFieldsForm, fields } = usePayPalCardFields();

  async function submitHandler() {
    if (!cardFieldsForm) return; // validate that `submit()` exists before using it
    const formState = await cardFieldsForm.getState();
    if (!formState.isFormValid) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("invalidCardDetails"),
        life: 6000,
      });
      return;
    }
    setIsPaying(true);
    cardFieldsForm
      .submit()
      .then(() => {
        console.log(fields);
      })
      .catch(() => {
        setIsPaying(false);
        console.log("error");
      });
  }
  return (
    <Button
      className="w-full mb-3"
      label={localeText("payNow")}
      loading={isPaying}
      onClick={submitHandler}
    ></Button>
  );
};
const PayPalCheckoutButton = (props) => {
  const { user, price, upgrade, plan_, toastUpgrade } = props;

  const [redirectCounting, setRedirectCounting] = useState(false);
  const [redirectCounter, setRedirectCounter] = useState(20);
  const orderId = useRef(null);
  const [isPaying, setIsPaying] = useState(false);
  const [idTransaction, setIdTransaction] = useState(null);

  const advancedPayPalService = new AdvancedPayPalService();
  const businessPartnerService = new BusinessPartnerService();
  const areaManagerService = new AreaManagerService();
  const sellerService = new SellerService();
  const getInfoService = new GetInfoService();
  const { showErrorToast } = useToastContext();

  async function registerUser(
    referee,
    username,
    email,
    documentNumber,
    fname,
    lname,
    password1,
    password2,
    language,
    currency,
    terms,
    marketingEmail,
    transactionID,
    plan,
    country,
    internationalCode,
    localCode,
    phoneNumber
  ) {
    try {
      if (plan === 1) {
        props.setLoading(true);

        let location;

        if (!localStorage.getItem("__extraconomy_lat__"))
          location = await getInfoService.getUserLocation();

        const res = await businessPartnerService.postRegisterBusinessPartner(
          referee,
          username,
          email,
          documentNumber,
          fname,
          lname,
          password1,
          currency,
          language,
          transactionID,
          country,
          internationalCode,
          localCode,
          phoneNumber,
          localStorage.getItem("__extraconomy_lat__")
            ? localStorage.getItem("__extraconomy_lat__")
            : location.latitude,
          localStorage.getItem("__extraconomy_long__")
            ? localStorage.getItem("__extraconomy_long__")
            : location.longitude
        );

        if (res.messageCode !== 200000) {
          showErrorToast({
            code: res.messageCode,
          });
          props.setLoading(false);
        } else {
          window.location.replace(
            "/emailconfirmation?title=" +
              localeText("emailConfirmationTitle") +
              "&message=" +
              localeText("emailConfirmationMessage") +
              "&type=success"
          );
        }
      } else if (plan === 2) {
        props.setLoading(true);

        let location;

        if (!localStorage.getItem("__extraconomy_lat__"))
          location = await getInfoService.getUserLocation();

        const res = await areaManagerService.postRegisterAreaManager(
          referee,
          username,
          email,
          documentNumber,
          fname,
          lname,
          password1,
          currency,
          language,
          transactionID,
          country,
          internationalCode,
          localCode,
          phoneNumber,
          localStorage.getItem("__extraconomy_lat__")
            ? localStorage.getItem("__extraconomy_lat__")
            : location.latitude,
          localStorage.getItem("__extraconomy_long__")
            ? localStorage.getItem("__extraconomy_long__")
            : location.longitude
        );

        if (res.messageCode !== 200000) {
          showErrorToast({
            code: res.messageCode,
          });
          props.setLoading(false);
        } else {
          window.location.replace(
            "/emailconfirmation?title=" +
              localeText("emailConfirmationTitle") +
              "&message=" +
              localeText("emailConfirmationMessage") +
              "&type=success"
          );
        }
      } else if (plan === 4) {
        props.setLoading(true);

        let location;

        if (!localStorage.getItem("__extraconomy_lat__"))
          location = await getInfoService.getUserLocation();

        const res = await sellerService.postRegisterSeller(
          referee,
          username,
          email,
          documentNumber,
          fname,
          lname,
          password1,
          currency,
          language,
          transactionID,
          country,
          internationalCode,
          localCode,
          phoneNumber,
          localStorage.getItem("__extraconomy_lat__")
            ? localStorage.getItem("__extraconomy_lat__")
            : location.latitude,
          localStorage.getItem("__extraconomy_long__")
            ? localStorage.getItem("__extraconomy_long__")
            : location.longitude
        );

        if (res.messageCode !== 200000) {
          showErrorToast({
            code: res.messageCode,
          });
          props.setLoading(false);
        } else {
          window.location.replace(
            "/emailconfirmation?title=" +
              localeText("emailConfirmationTitle") +
              "&message=" +
              localeText("emailConfirmationMessage") +
              "&type=success"
          );
        }
      } else {
        showErrorToast({
          detail: "invalidUserPlan",
        });
      }
    } catch (e) {
      props.setLoading(false);
      console.log(e);
    }
  }

  async function upgradeAccount(plan, transactionID) {
    try {
      if (plan === 1) {
        props.setLoading(true);
        const resBusiness = await businessPartnerService.upgrade(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          transactionID
        );

        if (resBusiness.messageCode !== 200000) {
          showErrorToast({ code: resBusiness.messageCode });
          props.setLoading(false);
        } else {
          toastUpgrade.current.show({
            severity: "success",
            summary: localeText("success"),
            detail: localeText("upgradedSuccessfully"),
            life: 6000,
          });
          counterStart();
        }
      } else if (plan === 2) {
        props.setLoading(true);
        const resAreaManager = await areaManagerService.upgrade(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          transactionID
        );

        if (resAreaManager.messageCode !== 200000) {
          showErrorToast({ code: resAreaManager.messageCode });
          props.setLoading(false);
        } else {
          toastUpgrade.current.show({
            severity: "success",
            summary: localeText("success"),
            detail: localeText("upgradedSuccessfully"),
            life: 6000,
          });
          counterStart();
        }
      } else {
        props.setLoading(true);
        const resSeller = await sellerService.upgrade(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          transactionID
        );

        if (resSeller.messageCode !== 200000) {
          showErrorToast({ code: resSeller.messageCode });
          props.setLoading(false);
        } else {
          toastUpgrade.current.show({
            severity: "success",
            summary: localeText("success"),
            detail: localeText("upgradedSuccessfully"),
            life: 6000,
          });
          counterStart();
        }
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      props.setLoading(false);
      console.log(e);
    }
  }

  function counterStart() {
    setRedirectCounting(true);
    let timesRun = 20;
    let interval = setInterval(() => {
      setRedirectCounter(timesRun);
      timesRun -= 1;
      if (timesRun === -1) {
        clearInterval(interval);
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
    }, 1000);
  }

  const createOrder = async () => {
    const payload = {
      amount: price,
      currency: "EUR",
      returnUrl: "https://example.com/success",
      cancelUrl: "https://example.com/cancel",
    };
    try {
      const res = await advancedPayPalService.createOrder(payload);
      orderId.current = res.id;
      return res.id;
    } catch (e) {
      console.log(e);
    }
  };
  const onApprove = async () => {
    try {
      const res = await advancedPayPalService.captureOrder(orderId.current);
      setIsPaying(false);
      setIdTransaction(res.id);
      if (!upgrade)
        registerUser(
          user.referee,
          user.username,
          user.email,
          user.documentNumber,
          user.fname,
          user.lname,
          user.password1,
          user.password2,
          user.language,
          user.currency,
          user.terms,
          user.marketingEmail,
          res.id,
          user.plan,
          user.country,
          user.internationalCode,
          user.localCode,
          user.phoneNumber
        );
      else {
        upgradeAccount(plan_, res.id);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      {!redirectCounting ? (
        <>
          {props.loading ? (
            <div className="text-center">
              <i className="pi pi-spin pi-spinner text-8xl text-500 my-6"></i>
            </div>
          ) : (
            <div className="text-center">
              <PayPalButtons
                disabled={false}
                fundingSource={undefined}
                options={{ currency: "EUR" }}
                createOrder={createOrder}
                onApprove={onApprove}
                onError={(e) => {
                  console.log(e);
                  showErrorToast({
                    detail: "unexpectedErrorTransaction",
                  });
                }}
              />
              <div className="flex justify-content-center align-items-center w-full flex-wrap gap-2 mx-auto mt-4">
                <img
                  src={paypalImg}
                  alt="paypal"
                  title="paypal"
                  style={{ width: "20px", height: "20px" }}
                />
                <img
                  src={americanExpress}
                  alt="americanExpress"
                  title="americanExpress"
                  style={{ width: "20px", height: "20px" }}
                />
                <img
                  src={masterCardImg}
                  alt="mastercard"
                  title="mastercard"
                  style={{ width: "30px", height: "20px" }}
                />
                <img src={visa} alt="visa" style={{ width: "35px", height: "15px" }} title="visa" />
              </div>
              <div className="flex justify-content-center align-items-center gap-2 mt-3">
                <p className="m-0 text-xs">{localeText("safePayment")}</p>
                <img
                  src={PagamentoSeguro}
                  alt=""
                  style={{ width: "20px" }}
                  title={localeText("safePayment")}
                />
              </div>
              <div className="mt-3">
                <h4 className="text-center text-lg font-semibold">
                  {localeText("creditCardInfo")}
                </h4>
              </div>
              <PayPalCardFieldsProvider
                options={{ currency: "EUR" }}
                createOrder={createOrder}
                onApprove={onApprove}
                onError={(e) => {
                  console.log(e);
                  showErrorToast({
                    detail: "unexpectedErrorTransaction",
                  });
                }}
              >
                <PayPalNameField placeholder={localeText("name")} />
                <PayPalNumberField placeholder={localeText("cardNumber")} />
                <PayPalExpiryField placeholder={localeText("expirationDate")} />
                <PayPalCVVField placeholder={localeText("securityCode")} />
                <SubmitPayment toast={toastUpgrade} isPaying={isPaying} setIsPaying={setIsPaying} />
              </PayPalCardFieldsProvider>
            </div>
          )}
        </>
      ) : (
        <div style={{ width: "90%" }} className="m-auto">
          <p className="w-full my-4">{localeText("upgradedSuccessfullyText")}</p>
          <div className="flex justify-content-center">
            <Button
              label={localeText("login")}
              className="p-button mt-2 mb-4"
              onClick={() => {
                localStorage.removeItem("__extraconomy_token");
                localStorage.removeItem("__extraconomy_username");
                window.location.replace("/login");
              }}
            />
          </div>
          <p className="font-bold text-xl mt-2 mb-6 text-center text-900">
            {localeText("youWillBeRedirectedIn")} {redirectCounter} {localeText("seconds")}
          </p>
        </div>
      )}
    </>
  );
};

export default PayPalCheckoutButton;
